import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/song/importer/songImporterActions'

export default importerReducers(actions)
